<template>
  <div class="formHeader">
    <!-- 公用头部 -->
    <!-- 头部 -->
    <div class="header">
      <!-- 左侧 -->
      <div class="header-left">
        <div class="header-left-one">
          <img
            class="header-left-img"
            src="@/assets/logo.png"
            alt=""
            srcset=""
          />
          <div class="header-left-text">{{ $t("locale.stingTV") }}</div>
        </div>
        <div class="header-left-tow">
          <div
            class="header-left-code"
            :class="{ active: key == '/home' }"
            @click="btnheader('/home')"
          >
            {{ $t("locale.home") }}
          </div>
          <div
            class="header-left-code"
            :class="{ active: key == '/ele' }"
            @click="btnheader('/ele')"
          >
            {{ $t("locale.genre") }}
          </div>
          <div class="header-left-code" v-if="key == '/home'">
            <el-dropdown trigger="click" @command="handleCommand">
              <div class="el-dropdown-link">
                <span v-if="lang=='en'">{{ $t("locale.en") }}</span>
                <span v-if="lang=='zh'">{{ $t("locale.zh-hans") }}</span>
                <span v-if="lang=='th'">{{ $t("locale.ko") }}</span>
                <span v-if="lang=='pt'">{{ $t("locale.pt") }}</span>
                <i class="el-icon-arrow-down el-icon--right"></i>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="en">
                  {{ $t("locale.en") }}
                </el-dropdown-item>
                <el-dropdown-item command="zh">
                  {{ $t("locale.zh-hans") }}
                </el-dropdown-item>
                <el-dropdown-item command="th">
                  {{ $t("locale.ko") }}
                </el-dropdown-item>
                <el-dropdown-item command="pt">
                  {{ $t("locale.pt") }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <!-- <div class="header-left-code" :class="{'active':key=='/target'}" @click="btnheader('/target')">Desktop</div> -->
        </div>
        <!-- <div class="header-left-tow">
        {{$t('langName')}}
        </div> -->
      </div>
      <!-- 右侧 -->
      <div class="header-right">
        <el-input
          :placeholder="$t('locale.details')"
          prefix-icon="el-icon-search"
          v-model="input"
          @change="change"
        >
        </el-input>

        <div class="header-avat" @click="btnheader('/Login')">
          <el-avatar
            icon="el-icon-user-solid"
            class="header-right-home"
          ></el-avatar>
        </div>
      </div>
    </div>
    <div class="posdata">
      <router-view :key="key" />
    </div>
    <!-- 底部 -->
    <div class="base">
      <div class="base-tab">
        <div>
          <div class="base-tab-one">ABOUT</div>
          <div class="base-tab-tow">Contact Us</div>
          <div class="base-tab-tow">Terms of Service</div>
          <div class="base-tab-tow">Privacy Policy</div>
        </div>
        <div>
          <div class="base-tab-one">SUPPORT</div>
          <!-- <div class="base-tab-tow">Feedback</div> -->
          <div class="base-tab-tow">Media & Public Relations</div>
        </div>
        <div>
          <div class="base-tab-one">COMMUNITY</div>
          <div class="base-tab-tow">Feedback</div>
        </div>
        <div></div>
      </div>
      <div class="base-text">
        <!-- All rights reserved.2024 Crazy Maple Studio lnc -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: "",
      lang:''
    };
  },
  computed: {
    key() {
      return this.$route.path;
    },
  },
  mounted() {
    this.lang = localStorage.getItem("lang") || "zh";
  },
  methods: {
    btnheader(url) {
      if (this.key != url) {
        this.$router.push({ path: url });
      }
    },
    change() {
      this.$router.push(`/ele?redirect=${this.input}`);
      this.input = "";
    },
    // 语言切换
    handleCommand(command) {
      localStorage.setItem("lang", command);
      this.lang = command;
      this.$i18n.locale = command;
      console.log(this.$i18n.locale);
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.posdata {
  min-height: 650px;
  margin-top: 80px;
  background-color: #000;
  color: #fff;
}
.formHeader {
  /* height: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 999;
  padding: 20px 120px;
  background-color: #000;
  color: #fff;
  display: flex;

  justify-content: space-between;
}
.header-left {
  display: flex;
}
.header-right {
  display: flex;
}
.header-right-home {
  text-align: center;
  margin-left: 20px;
  font-size: 14px;
  font-weight: 700;
}
.header-left-one {
  display: flex;
  margin-right: 60px;
  line-height: 40px;
}
.header-left-img {
  margin-right: 20px;
  width: 40px;
  height: 40px;
}
.header-left-tow {
  display: flex;
  line-height: 40px;
  font-weight: 700;
}
.header-left-code {
  margin-right: 20px;

  cursor: pointer;
}
.header-left-text {
  font-size: 20px;
  font-weight: 700;
}
.base {
  padding: 40px 120px 20px;
  background-color: #111111;
  color: #fff;
}
.base-text {
  color: #999;
  margin-top: 40px;
  text-align: center;
}
.base-tab {
  display: flex;
  justify-content: space-between;
}
.base-tab-one {
  font-size: 20px;
  font-weight: 700;
}
.base-tab-tow {
  margin-top: 20px;
  color: #999;
}
.header-avat {
  width: 80px;
}
.active {
  color: #ff375f;
}
.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
/deep/ .el-popper {
  background-color: #111111 !important;
}
</style>